import React, { useEffect, useState } from 'react';
import MasterLayout from '../components/layouts/MasterLayout';
import PageContentLayout from '../components/layouts/PageContentLayout';
import FormHeader from '../components/user/FormHeader';
import FormInput from '../components/elements/FormInput';
import { useTranslation } from 'react-i18next';
import { useBrowser } from '../contexts/BrowserContext';
import { Button, Flex } from 'antd';
import RulesPage from './RulesPage';
import HelpPage from './HelpPage';

const SettingPage = () => {
    const { t } = useTranslation();

    const { browser, browserLoading } = useBrowser();
    const [downloadPath, setDownloadPath] = useState("");
    const getDownloadPath = async ()=>{
        if (!browserLoading)
            setDownloadPath(await browser?.getDownloadPath());
    }
    const setPath = async ()=>{
        if (!browserLoading)
            setDownloadPath(await browser.appUserSelectDownloadFolder());
    }
    useEffect( () => {
        getDownloadPath()
    }, [browserLoading]);


    return (
        // <MasterLayout>
            <PageContentLayout>
                <FormHeader title={t('menu.setting')} icon={<span className="svg-icon icon-user" style={{ fontSize: 28 }}></span>}>
                </FormHeader>
                <FormInput label={t('download.download_path')} value={downloadPath} />

                <div>
                    <Button type="primary" className="change-dir-btn"  onClick={() => {
                        setPath();
                    }}>{t('download.change')}</Button>
                </div>

            </PageContentLayout>
        // </MasterLayout>
    );
};

export default SettingPage; 
